import { gql } from 'graphql-request'

export const FCreditPrice = gql`
    fragment FCreditPrice on CreditsPriceConverted {
        value
        formattedValue
    }
`
